export const openDb = async (dbVersion) => {
    return new Promise((resolve, reject) => {
        if (typeof indexedDB === 'undefined') {
            reject(new Error('indexedDB is not available in this environment'));
            return;
        }
        const request = indexedDB.open('dams', dbVersion);
        if (!request) {
            reject(new Error('Failed to open indexedDB'));
            return;
        }
        request.onsuccess = (event) => resolve(event.target.result);
        request.onerror = (event) => reject(event.target.error);
    });
};


